import { useTranslation } from 'react-i18next';

import * as S from './style';

type Leader = {
	affiliation: string;
	name: string;
};

type Committee = {
	chairs: Leader[];
	members: string[];
	name: string;
	viceChairs: Leader[];
};

type CommitteeTranslation = {
	headers: {
		affiliation: string;
		chair: string;
		members: string;
		name: string;
		section: string;
		viceChair: string;
	};
	items: Committee[];
};

const CommitteeList = () => {
	const { t } = useTranslation();
	const committees = t('introduce.committees', { returnObjects: true }) as CommitteeTranslation;

	return (
		<S.CommitteeListContainer>
			<S.TablePanel>
			<S.Table>
				<S.HeaderCell style={{ gridRow: 'span 2' }}>{committees.headers.section}</S.HeaderCell>
				<S.HeaderCell style={{ gridColumn: 'span 2' }}>{committees.headers.chair}</S.HeaderCell>
				<S.HeaderCell style={{ gridColumn: 'span 2' }}>{committees.headers.viceChair}</S.HeaderCell>
				<S.HeaderCell style={{ gridRow: 'span 2' }}>{committees.headers.members}</S.HeaderCell>
				<S.HeaderCell>{committees.headers.affiliation}</S.HeaderCell>
				<S.HeaderCell>{committees.headers.name}</S.HeaderCell>
				<S.HeaderCell>{committees.headers.affiliation}</S.HeaderCell>
				<S.HeaderCell>{committees.headers.name}</S.HeaderCell>

				{committees.items.flatMap((committee) => {
					const rowCount = Math.max(committee.chairs.length, committee.viceChairs.length, 1);

					return Array.from({ length: rowCount }, (_, index) => {
						const chair = committee.chairs[index];
						const viceChair = committee.viceChairs[index];
						const shouldMergeChairCells = committee.chairs.length === 1 && rowCount > 1;

						return [
							index === 0 ? (
								<S.Cell key={`${committee.name}-name`} className="section" style={{ gridRow: `span ${rowCount}` }}>
									{committee.name}
								</S.Cell>
							) : null,
							index === 0 || !shouldMergeChairCells ? (
								<S.Cell
									key={`${committee.name}-chair-affiliation-${index}`}
									style={index === 0 && shouldMergeChairCells ? { gridRow: `span ${rowCount}` } : undefined}
								>
									{chair?.affiliation ?? ''}
								</S.Cell>
							) : null,
							index === 0 || !shouldMergeChairCells ? (
								<S.Cell
									key={`${committee.name}-chair-name-${index}`}
									style={index === 0 && shouldMergeChairCells ? { gridRow: `span ${rowCount}` } : undefined}
								>
									{chair?.name ?? ''}
								</S.Cell>
							) : null,
							<S.Cell key={`${committee.name}-vice-affiliation-${index}`}>{viceChair?.affiliation ?? ''}</S.Cell>,
							<S.Cell key={`${committee.name}-vice-name-${index}`}>{viceChair?.name ?? ''}</S.Cell>,
							index === 0 ? (
								<S.Cell key={`${committee.name}-members`} className="members" style={{ gridRow: `span ${rowCount}` }}>
									{committee.members.join(', ')}
								</S.Cell>
							) : null,
						];
					});
				})}
			</S.Table>
			</S.TablePanel>
		</S.CommitteeListContainer>
	);
};

export default CommitteeList;
